<template>
	<div class="add_user_wrap">
    <el-button type="primary" size="small"  @click="pop_show = true">增加用户</el-button>
      <el-dialog title="增加用户" :visible.sync="pop_show" append-to-body>
        <el-form :model="userForm" status-icon :rules="rulesUserForm" ref="userForm" label-width="100px">
          <el-form-item label="账号:" prop="account">
            <el-input type="text" v-model="userForm.account" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="用户名:" prop="name">
            <el-input type="text" v-model="userForm.name" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password">
            <el-input type="password" v-model="userForm.password" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item @click='fn' label="选择头像:" prop="profile_photo">
            <el-input id='box' v-if='userForm.profile_photo === ""' type="file" @change="changeFile()" autocomplete="off" size="small" class="head_ph"></el-input>
            <img class="head_img" v-else :src="userForm.profile_photo">
          </el-form-item>
          <el-form-item label="介绍:" prop="introduction">
            <el-input type="text" v-model="userForm.introduction" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile">
            <el-input type="text" v-model="userForm.mobile" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input type="text" v-model="userForm.email" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="gender">
            <template>
              <el-radio-group v-model="userForm.gender">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="地区:" prop="area">
            <el-input type="text" v-model="userForm.area" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="公司:" prop="company">
            <el-input type="text" v-model="userForm.company" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="职业:" prop="career">
            <el-input type="text" v-model="userForm.career" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('userForm')">提交</el-button>
            <el-button @click="resetForm('userForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';


export default {
  name: 'AddUser',
  data () {
    var validateAccount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('账号不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('账号是5到20位数字、字母或下划线'));
          }
        }
    };
    var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('用户名不能为空!'));
        } else {
          var reUser = /^.{1,7}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('用户名是1到7位数字、字母或下划线'));
          }
        }
    };
    var validatePassWord = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码不能为空!'));
        } else {
          var rePass = /^[\w!@#$%^&*]{8,20}$/;
          if(rePass.test(value))
          {
            if(/^([a-z].*[0-9])|([A-Z].*[0-9])|([0-9].*[a-zA-Z])$/.test(value)){
              callback()
            }else{
              callback(new Error('密码中至少应包含数字、字母或特殊符号中的两种'));
            }
          }else{
             callback(new Error('密码是8到20位数字、字母或下划线以及特殊!@#$%^&*符号'));
          }
        }
    };
    var validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空!'));
        } else {
          var rePhone = /^1[34578]\d{9}$/;
          if(rePhone.test(value))
          {
            callback()
          }else{
             callback(new Error('手机格式不正确'));
          }
        }
    };
    var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('邮箱不能为空!'));
        } else {
          var rePhone = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
          if(rePhone.test(value))
          {
            callback()
          }else{
             callback(new Error('邮箱式不正确'));
          }
        }
    };
    return {
      pop_show:false,
      userForm:{
        account: '',
        name:'',
        password:'',
        profile_photo: '',
        mobile:'',
        email:'',
        gender:'',
        area:'',
        company:'',
        career:'',
        introduction:''
      },
      rulesUserForm:{
        account: [
            { validator: validateAccount, trigger: 'blur' }
        ],
        name: [
            { validator: validateName, trigger: 'blur' }
        ],
        password: [
            { validator: validatePassWord, trigger: 'blur' }
        ],
        mobile: [
            { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
            { validator: validateEmail, trigger: 'blur' }
        ],
      }
    }
  },
  methods:{
    submitForm(formName){
      let token = localStorage.token;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.userForm.gender === ''){
            this.$message({
                    type: 'error',
                    message: '请选择性别！'
                  });
            return
          }
          console.log(this.userForm.profile_photo, this.userForm.name)
          this.axios.post(cons.apis + '/v1_0/users', {
                "name": this.userForm.name,
                "mobile": this.userForm.mobile,
                "password": this.userForm.password,
                "email": this.userForm.email,
                "account": this.userForm.account,
                // "profile_photo": this.userForm.profile_photo,
                "introduction": this.userForm.introduction,
                "gender": this.userForm.gender,
                "area": this.userForm.area,
                "company": this.userForm.company,
                "career": this.userForm.career,
              }, {
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType: 'json'
          })
          .then(dat=>{
              if(dat.status==201){
                this.$message({
                  type: 'success',
                  message: '添加用户成功!'
                });
                this.$emit('fnSetKey',this.userForm.username);
                this.pop_show = false;
                this.resetForm('userForm');
              }
          }).catch(err=>{
              console.dir(err.response)
             if(err.response.status==403){
                var errmsg = err.response.data;
                if(errmsg.message.indexOf('already exists') >= 0){
                  this.$message({
                    type: 'error',
                    message: errmsg.message.replace('already exists','已存在')
                  });
                }

             }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    changeFile() {
        var that = this;
        var file = event.target.files[0];
        var a = new FileReader();
        a.onload = function (e) {
            var base64Str = e.target.result;//获取base64
            // console.log(base64Str)
            //下面是测试得到的base64串能否正常使用：
            that.userForm.profile_photo = base64Str;
        }
        a.readAsDataURL(file);
    },
    fn(){
      document.getElementById('box').click()
    }
  }
}
</script>

<style scoped>
  .input_width{
    width:450px;
  }
  .head_ph, .head_img {
    display: block;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dashed #ccc;
    border-radius: 3px;
  }
  .head_ph:hover, .head_img:hover {
    border: 1px dashed red;
  }


</style>



// WEBPACK FOOTER //
// src/components/widget/AddUser.vue